import { theme } from '@jadwalh/ui';
import styled from 'styled-components';

export const SectionContainer = styled.section`
  width: 100%;
  position: relative;
  /* @media (max-width: 767.5px) {
    padding: 16px 12px;
  } */
  p {
    margin-bottom: 0 !important;
  }
  .detail_container {
    /* padding: 16px 0 8px; */
    .title {
      line-height: 17px;
      font-size: 13px;
      color: #000;
    }
    .item {
      width: 180px;
      height: 180px;
      border: 1px solid ${theme.colours.BrightGray};
      border-radius: 12px;
      img {
        width: 95px;
        height: 95px;
      }
    }
    .info {
      /* min-height: 187px; */
      p {
        font-size: 13px;
        font-weight: 400;
        line-height: 17px;
        color: #000;
      }
      ul {
        padding-inline-start: 16px;
        list-style: none;
        /* width: 446px;
        @media (max-width: 768px) { */
        width: 100%;
        /* } */
        li {
          font-size: 13px;
          font-weight: 400;
          line-height: 22px;
          color: ${theme.colours.black};
          &:lang(ar) {
            &::before {
              right: -10px;
            }
          }
          &:lang(en) {
            &::before {
              left: -10px;
            }
          }
          &::before {
            position: absolute;
            content: '•';
            color: #000;
            font-size: 20px;
            top: 12px;
            transform: translateY(-50%);
          }
        }
      }
    }
    .border {
      width: 100%;
      height: 0.5px;
      background-color: #d4d4d4;
    }
  }
  button {
    background-color: #242424;
    color: #fff;
    height: 32px;
    width: 85px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 400;
    margin-top: 16px;
    line-height: 20px;
    &:hover {
      background-color: #242424;
    }
    @media (max-width: 768px) {
      width: 100%;
    }
  }
`;
